class SlideButtonSwicher
{
  constructor (prevButton, nextButton, itemLength) {
    this.index = 0;
    this.itemLength = itemLength;
    this.prevButton = prevButton;
    this.nextButton = nextButton;
    this.switchButton();
  }

  switchButton () {
    if (this.index <= 0) {
      this.prevButton.hide();
    } else {
      this.prevButton.show();
    }
    if (this.index >= (this.itemLength - 1)) {
      this.nextButton.hide();
    } else {
      this.nextButton.show();
    }
  }

  prev () {
    if (this.index <= 0) {
      return;
    }
    this.index--;
    this.switchButton();
  }

  next () {
    if (this.index >= (this.itemLength -1)) {
      return;
    }
    this.index++;
    this.switchButton();
  }
}

const translateX = (target, distance) => {
  target.css({
    'transform': `translateX(${distance}%)`,
    'webkitTransform': `translateX(${distance}%)`
  });
};

$(() => {
  $('.js-slide').each((index, slide) => {
    const wrapper = $(slide).children('.js-slideWrapper').first();
    const wrapperItems = wrapper.children('.js-slideWrapperItem');
    const wrapperItemWidth = 100 / wrapperItems.length;

    $(slide).css({'overflow': 'hidden'});
    wrapper.css({'width': (wrapperItems.length * 100) + '%'});
    translateX(wrapper, 0);
    wrapper.addClass('u-clearfix');
    wrapperItems.css({'width': wrapperItemWidth + '%', 'float': 'left'});

    const prevButton = $(slide).children('.js-slidePrev');
    const nextButton = $(slide).children('.js-slideNext');
    const buttonSwitcher = new SlideButtonSwicher(prevButton, nextButton, wrapperItems.length);

    $(slide).on('click', '.js-slidePrev', (e) => {
      e.stopPropagation();
      buttonSwitcher.prev();
      translateX(wrapper, (-1 * buttonSwitcher.index * wrapperItemWidth));
    });
    $(slide).on('click', '.js-slideNext', (e) => {
      e.stopPropagation();
      buttonSwitcher.next();
      translateX(wrapper, (-1 * buttonSwitcher.index * wrapperItemWidth));
    });
  });
});
